/* Copyright (c) 2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Detail, DetailData } from "./Detail";

type Props = {
  details: DetailData[];
};

export function Details({ details }: Props) {
  return (
    <>
      {details.map((detail) => (
        <Detail key={detail.label || ""} detail={detail} />
      ))}
    </>
  );
}
